import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import syncReducer from './slices/sync';
import tournamentsReducer from './slices/tournaments';
import tournamentParticipantsReducer from './slices/tournament-participants';
import tournamentSchedulesReducer from './slices/tournament-schedules';
import tournamentScheduleItemsReducer from './slices/tournament-schedule-items';

export const rootPersistConfig = {
    key: 'root',
    storage,
    keyPrefix: 'redux-',
    whitelist: [],
};

const rootReducer = combineReducers({
    sync: syncReducer.getReducer(),
    tournaments: tournamentsReducer.getReducer(),
    tournamentParticipants: tournamentParticipantsReducer.getReducer(),
    tournamentSchedules: tournamentSchedulesReducer.getReducer(),
    tournamentScheduleItems: tournamentScheduleItemsReducer.getReducer(),
});

export default rootReducer;
